import { SecurityGraphBackdrop } from '@/components/common/SecurityGraphBackdrop'
import { SuggestedInvestigations } from './SuggestedInvestigations'
import styles from './WelcomeCanvas.module.css'

interface WelcomeCanvasProps {
  onSelectPrompt: (prompt: string) => void
}

export function WelcomeCanvas({ onSelectPrompt }: WelcomeCanvasProps) {
  return (
    <div className={styles.root}>
      <SecurityGraphBackdrop />
      <div className={styles.content}>
        <h1 className={styles.headline}>Cum te pot ajuta să investighezi?</h1>
        <p className={styles.subheading}>
          Corelez incidente, identități și endpoint-uri folosind datele disponibile din
          ecosistemul Microsoft Security.
        </p>
        <SuggestedInvestigations onSelect={onSelectPrompt} />
      </div>
    </div>
  )
}
